
import * as z from "zod";

export const profileFormSchema = z.object({
  bio: z.string().max(500, "Bio must be less than 500 characters"),
  city: z.string().min(1, "City is required"),
  country: z.string().min(1, "Country is required"),
  languages: z.string(),
  hosting_style: z.array(z.string()).default([]),
  specialties: z.string().optional(),
  nationality: z.string().optional(),
});

export type ProfileFormData = z.infer<typeof profileFormSchema>;
